var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("textarea", {
    directives: [
      {
        name: "model",
        rawName: "v-model",
        value: _vm.localValue,
        expression: "localValue",
      },
    ],
    attrs: { id: _vm.id, maxlength: _vm.maxLength },
    domProps: { value: _vm.localValue },
    on: {
      input: [
        function ($event) {
          if ($event.target.composing) {
            return
          }
          _vm.localValue = $event.target.value
        },
        _vm.handleInput,
      ],
      change: _vm.handleChange,
      keyup: _vm.handleKeyUp,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }